module.exports = __webpack_public_path__ + "img/d08.2add19ff.png";